import {Atributos, Model} from './model.module.js'

export default class Manobra extends Model {
	model = 'Manobra'

	atributos = {
		id: new Atributos('0', {required: true}),
		descricao: new Atributos('', {required: true})
	}

	loadIn(text) {
		window.bus.$emit('load-in', {text})
	}

	loadOut() {
		window.bus.$emit('load-out')
	}

	notify(options) {
		window.bus.$emit('exibir-notificacao', options)
	}

	async salvar() {
		if (!this.isValid()) {
			this.notify({
				type: 'danger',
				text: this._traducao('menuEscala', 'menuEvermelho')
			})
			return false
		}
		return new Promise((resolve, reject) => {
			this.loadIn(this._traducao('global', 'salvando'))
			this._axios(`/${this.model}/salvar`, 'post', {
				data: this.toModel(this.atributos),
				callback: (retorno) => {
					const {_status, _request} = retorno
					_status && _request ? resolve(retorno) : reject(retorno)
				},
				finally: this.loadOut
			})
		})
	}

	async all() {
		return new Promise((resolve, reject) => {
			this.loadIn(this._traducao('global', 'carregando'))
			this._axios(`/${this.model}/lista`, 'get', {
				callback: (retorno) => {
					const {_status, _request} = retorno
					_status && _request ? resolve(retorno) : reject(retorno)
				},
				finally: this.loadOut
			})
		})
	}

	async get(id) {
		return new Promise((resolve, reject) => {
			this.loadIn(this._traducao('global', 'carregando'))
			this._axios(`/${this.model}/get/${id}`, 'get', {
				callback: (retorno) => {
					const {_status, _request} = retorno
					_status && _request ? resolve(retorno) : reject(retorno)
				},
				finally: this.loadOut
			})
		})
	}

	async excluir(id) {
		return new Promise((resolve, reject) => {
			this.loadIn(this._traducao('global', 'excluindo'))
			this._axios(`/${this.model}/excluir/${id}`, 'get', {
				callback: (retorno) => {
					const {_status, _request} = retorno
					_status && _request ? resolve(retorno) : reject(retorno)
				},
				finally: this.loadOut
			})
		})
	}

	async desativar(id) {
		return new Promise((resolve, reject) => {
			this.loadIn(this._traducao('global', 'carregando'))
			this._axios(`/${this.model}/desativar/${id}`, 'get', {
				callback: (retorno) => {
					const {_status, _request} = retorno
					_status && _request ? resolve(retorno) : reject(retorno)
				},
				finally: this.loadOut
			})
		})
	}

	async reativar(id) {
		return new Promise((resolve, reject) => {
			this.loadIn(this._traducao('global', 'carregando'))
			this._axios(`/${this.model}/reativar/${id}`, 'get', {
				callback: (retorno) => {
					const {_status, _request} = retorno
					_status && _request ? resolve(retorno) : reject(retorno)
				},
				finally: this.loadOut
			})
		})
	}
}


